export default __webpack_public_path__ + "f7527f818b646845ca7d15a7edf42b12.png";